if (!customElements.get("filters-toolbar")) {
  customElements.define("filters-toolbar", class FiltersToolbar extends HTMLElement {
    constructor() {
      super();

      this.mobileOpener = document.querySelector('.collection-open-filters');
      if (this.mobileOpener) this.mobileOpener.addEventListener('click', () => { this.openFiltersOnMobile() });
      this.mobileCloser = document.querySelector('.filters-close');
      this.mobileConfirm = document.querySelector('.filters-confirm');
      if (this.mobileCloser) this.mobileCloser.addEventListener('click', () => { this.closeFiltersOnMobile() });
      if (this.mobileConfirm) this.mobileConfirm.addEventListener('click', () => { this.closeFiltersOnMobile() });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' || event.key === 'Esc') this.closeFiltersOnMobile(); });

      this.sortByOption = this.querySelector('.param-sorting');
      if (this.sortByOption) this.sortByOption.querySelector('.remove-filter').addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      })
      
      this.triggers = this.querySelectorAll('.filters-trigger');
      this.triggers.forEach(trigger => {
        const trigggerButton = trigger.querySelector('button');
        trigggerButton.addEventListener('click', () => { this.openAccordion(trigger) })
      });

      this.originalParams = window.filters;
      this.inputs = this.querySelectorAll('.filters-element input');
      this.products = document.querySelectorAll('.product-card');
      this.resetButtons = document.querySelectorAll('.filters-reset');
      this.totalNumberOfFilters = document.querySelectorAll('.number-of-filters');

      this.resetButtons.forEach(button => button.addEventListener('click', () => this.resetFilters()));

      this.params = this.getFiltersFromUrl();
      this.buildParams();
      window.onload = () => {
        this.applyFilters(this.params);
        this.createActiveParams(this.params);
        this.updateProductVisibility(this.params);
        this.updateFilterCount(this.params);
      };
    }

    openFiltersOnMobile() {
      document.body.classList.add('filters-open');
      this.classList.add('open');
    }

    closeFiltersOnMobile() {
      document.body.classList.remove('filters-open');
      this.classList.remove('open');
    }
    
    updateData() {
      this.params = this.getFiltersFromUrl();
      this.inputs = this.querySelectorAll('.filters-element input');
      this.products = document.querySelectorAll('.product-card');
      this.buildParams();
      this.applyFilters(this.params);
      this.createActiveParams(this.params);
      this.updateProductVisibility(this.params);
      this.updateFilterCount(this.params);
    }

    openAccordion(trigger) {
      const content = document.getElementById(trigger.dataset.open);

      if (trigger.classList.contains('open')) {
        trigger.classList.remove('open');
        content.classList.add('hidden');
      } else {
        trigger.classList.add('open');
        content.classList.remove('hidden');
      }
    }

    getFiltersFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const filters = window.filters;
  
      for (const key in filters) {
        if (params.has(key)) {
          filters[key] = params.get(key).split(',');
        }
      }
  
      return filters;
    }

    applyFilters(filters) {
      for (const category in filters) {
        filters[category].forEach(value => {
          const checkbox = document.querySelector(`input[name="${this.toKebabCase(category)}"][value="${value}"]`);
          if (checkbox) {
            checkbox.checked = true;
          }
        });
      }

      this.updateFilterCount(filters);
    }

    newParam(value, name, toAdd = true) {
      const paramContainer = this.querySelector('.filters-current');
      const newParamHTML = `
        <div class="filters-new-param" id="${value}" data-name="${name}">
          <span>${value}</span>
          <p data-remove="${value}" class="remove-filter">${'&times;'}</p>
        </div>
      `;
      const paramAdded = document.getElementById(value);
    
      if (toAdd) {
        if (!paramAdded) {
          paramContainer.classList.remove('hidden');
          paramContainer.insertAdjacentHTML('beforeend', newParamHTML);
        }
      } else {
        if (paramAdded) {
          paramAdded.remove();
        }
        if (!paramContainer.querySelector('.filters-new-param')) {
          paramContainer.classList.add('hidden');
        }
      }
    
      this.handleRemoveFilter(value, name);
    }
    
    handleRemoveFilter(filterId, filterName) {
      const removeButton = document.querySelector(`[data-remove="${filterId}"]`);
      if (removeButton) {
        removeButton.addEventListener('click', () => {
          const input = document.querySelector(`input[value="${filterId}"]`);
          if (input) input.checked = false;

          const category = this.toCamelCase(filterName);
          const index = this.params[category].indexOf(filterId);
  
          if (index !== -1) {
            this.params[category].splice(index, 1);
          }
  
          this.updateProductVisibility(this.params);
          this.updateFilterCount(this.params);
          this.buildUrl(this.params);

          this.newParam(filterId, filterName, false);
        });
      }
    }

    buildParams() {
      this.inputs.forEach(input => {
        input.addEventListener('change', () => {
          const categoryArray = this.params[this.toCamelCase(input.name)];
          if (input.checked) {
            if (!categoryArray.includes(input.value)) {
              categoryArray.push(input.value);
            }
            this.newParam(input.value, input.name, true);
          } else {
            const index = categoryArray.indexOf(input.value);
            if (index !== -1) {
              categoryArray.splice(index, 1);
            }
            this.newParam(input.value, input.name, false);
          }
          this.updateProductVisibility(this.params);
          this.updateFilterCount(this.params);
          this.buildUrl(this.params);
        });
      });
    }

    createActiveParams(filters) {
      for (const category in filters) {
        filters[category].forEach(value => {
          const categoryKebab = this.toKebabCase(category);
          this.newParam(value, categoryKebab, true);
        });
      }
    }

    updateFilterCount(filters) {
      for (const category in filters) {
        const count = filters[category].length;
        const counterElement = document.querySelector(`.filters-number#${this.toKebabCase(category)}`);
        if (counterElement) {
          if (count > 0 && this.inputs.length > 0) {
            counterElement.textContent = count;
            counterElement.classList.remove('hidden');
          } else {
            counterElement.classList.add('hidden');
          }
        }
      }

      const allSingleNumbers = this.querySelectorAll('.filters-number');
      let counter = 0;
      allSingleNumbers.forEach(el => {
        if (!el.classList.contains('hidden')) counter += +el.textContent
      });
      this.totalNumberOfFilters.forEach(el => {
        const parent = el.closest('.number-of-filters-parent');
        if (counter > 0) {
          if (parent) parent.classList.remove('hidden');
          el.classList.remove('hidden');
          el.textContent = `(${counter})`
        } else {
          if (parent) parent.classList.add('hidden');
          el.classList.add('hidden');
          el.textContent = "(0)";
        }
      })
    }

    toCamelCase(str) {
      return str
        .split('-')                 
        .map((word, index) => {
          if (index === 0) {
            return word.toLowerCase();  
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('');  
    }

    toKebabCase(str) {
      return str
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase();                    
    }

    updateProductVisibility(filters) {
      this.products.forEach(product => {
        let isVisible = true;

        for (const category in filters) {
          if (filters[category].length > 0) {
            const productValue = product.dataset[category];
            if (!filters[category].includes(productValue)) {
              isVisible = false;
              break;
            }
          }
        }

        const parent = product.closest('.grid__item--collection-template');
        if (parent) parent.style.display = isVisible ? 'block' : 'none';
      });
    }

    buildUrl(paramsObject) {
      const currentParams = new URLSearchParams(window.location.search);
      
      for (const key in paramsObject) {
        if (paramsObject[key].length > 0) {
          currentParams.set(key, paramsObject[key].join(','));
        } else {
          currentParams.delete(key);
        }
      }

      const newUrl = `${window.location.pathname}?${currentParams.toString()}`;
      window.history.pushState(null, '', newUrl);
    }

    resetFilters() {
      this.params = { "typeDeBijoux": [], "matiere": [] };
    
      if (this.inputs) {
        this.inputs.forEach(input => { input.checked = false; });
      }
    
      const filterParams = this.querySelectorAll('.filters-new-param');
      filterParams.forEach(param => param.remove());
    
      const paramContainer = this.querySelector('.filters-current');
      if (paramContainer) {
        paramContainer.classList.add('hidden');
      }
    
      this.updateProductVisibility(this.params);
      this.updateFilterCount(this.params);
      this.buildUrl(this.params);
    }
  })
}